import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function BespokeShutterSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="32773" id="get-in-touch" ref={ref} className="relative flex min-h-[85vh] w-full flex-col items-center justify-center overflow-hidden dark bg-background border-y border-secondary/30 px-4 py-32 text-center sm:px-8">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,_rgba(155,135,175,0.15)_0%,_transparent_60%)]" />

      <div className={`relative z-10 mx-auto flex max-w-4xl flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <h1 className="mb-6 font-serif text-5xl font-light leading-[1.1] tracking-tight text-foreground sm:text-6xl md:text-[64px]">
          Join the
          <br />
          Cobrnik Family
        </h1>

        <p className="mb-10 max-w-2xl font-sans text-lg font-light leading-relaxed text-muted-foreground sm:text-xl">We invite you to begin your journey with us with an application. Our application process is thoughtfully designed to ensure our Cavaliers find the perfect forever homes where they will be cherished for a lifetime.</p>

        <div className="group relative">
          <Button asChild className="relative h-16 overflow-hidden rounded-full bg-primary px-12 text-lg font-medium tracking-wide text-primary-foreground shadow-lg transition-all duration-500 hover:bg-primary/90 hover:shadow-primary/20 hover:shadow-2xl">
            
          </Button>
        </div>
      </div>
    </section>;
}